<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myapplication.request_appeal.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myapplication.title') }} > </span>
            <span class="middle_loc">{{ application_no }} > </span>
            <span class="back_loc">{{ $t('myapplication.request_appeal.title') }}</span>
        </span>
      </h2>

      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01 ">
              <h2>{{ $t('myapplication.request_appeal.fields.step_01') }}</h2>
              <p>{{ $t('myapplication.request_appeal.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step02 active">
              <h2>{{ $t('myapplication.request_appeal.fields.step_02') }}</h2>
              <p>{{ $t('myapplication.request_appeal.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout column class="ma-0 pos-r center__wrapper mt-30">
            <v-flex class="inner_basic_wrap type2">
              <v-tabs
                class="my_app_tabs_data type2"
                hide-slider
                grow
              >
                <v-tab class="mw-200">{{ $t('myapplication.request_appeal.fields.review_your_application') }}</v-tab>
                <v-tab class="mw-200">{{ $t('modification.voluntaryamendment.fields.attached_documents')  }}</v-tab>

                <v-tab-item>
                  <ApplicationInformation
                    :receipt_no.sync = receipt_no
                  />
                </v-tab-item>

                <v-tab-item>
                  <DocumentViewer
                    :items="documentFileList"
                  />
                  <v-divider class="mt-25 mb-25"></v-divider>
                </v-tab-item>

              </v-tabs>
            </v-flex>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-btn
                color="primary"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnGoBefore()"
              >{{ $t('common.button.before') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                dark
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                @click="fnSubmit()"
              >{{ $t('common.button.submit') }}</v-btn>
            </v-col>
          </v-row>
        </v-flex>


      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ApplicationInformation from '@/components/layout/ApplicationInformation'
import DocumentViewer from '@/components/layout/DocumentViewer'

export default {
  components :{
    ApplicationInformation,
    DocumentViewer
  },
  data() {
    return {
      application_no : '',
      application_seq : '',
      receipt_no : this.$route.params.receipt_no,
      documentFileList: []
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnGetApplicationInfo()
    this.fnGetDocumentFileList()
  },
  methods : {

    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetApplicationInfo(){
      requestApi({
        url: '/applications/search/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            if(res.data){
              this.application_no = res.data.application_no
              this.application_seq = res.data.application_seq
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicationInfo()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoBefore(){
      this.$router.push({path:'/myapplication/requestappeal/step1/' + this.receipt_no})
    },

    fnSubmit(){
      requestApi({
        url: '/receivings/appeal/'+this.receipt_no+'/submit',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {

            let option = {
              text : this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', option)

            this.$router.push({ name : 'myapplication-view' , params : { seq : ''+this.application_seq, active_tab : 1 }} )

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  }
}
</script>